import { PersonAvatar } from "~/components/PersonAvatar";
import useUser from "~/contexts/user";
import { SettingsGroup } from "~/pages/manifold-nextgen/components/settings/SettingsGroup";
import { SettingsPage } from "~/pages/manifold-nextgen/components/settings/SettingsPage";
import { ProfileGroupsSection } from "./ProfileGroupsSection";

/**
 * The profile's Account tab: who the user is, and which groups place them in the
 * organization. Read-only — identity comes from the identity provider and
 * membership from Access Controller, not from this form. The page says so up
 * front, so the absence of any control here reads as by design rather than as a
 * page that failed to load its form.
 */
export const ProfileAccountTab = () => {
  const user = useUser();

  const displayName = user?.name ?? user?.email ?? "";

  return (
    <SettingsPage
      title="Account"
      description="Your identity and group memberships. They are shown here, and changed by an administrator."
    >
      <SettingsGroup>
        <div className="flex items-center gap-4 px-4 py-4">
          <PersonAvatar name={displayName} email={user?.email} imageUrl={user?.picture} size={56} />
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-foreground">{displayName}</p>
            <p className="truncate text-xs text-muted-foreground">{user?.email ?? ""}</p>
          </div>
        </div>
      </SettingsGroup>

      <ProfileGroupsSection />
    </SettingsPage>
  );
};
